export const TransferenciaModais = {
  cadastrarTransferencia: 'cadastrarTransferencia',
};
